/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_EditInputs */

const he_account_notifications_edit = /** @type {(inputs: Account_Notifications_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ערוך התראה`)
};

const en_account_notifications_edit = /** @type {(inputs: Account_Notifications_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit notification`)
};

/**
* | output |
* | --- |
* | "Edit notification" |
*
* @param {Account_Notifications_EditInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_edit = /** @type {((inputs?: Account_Notifications_EditInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_EditInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_edit(inputs)
	return en_account_notifications_edit(inputs)
});